var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgBarcodeScanner = function (props) { return (_jsx("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M21 9V7h-2v2h2ZM9 5V3H7v2h2ZM5 21h14c1.1 0 2-.9 2-2v-4h-2v4H5v-4H3v4c0 1.1.9 2 2 2ZM3 5h2V3c-1.1 0-2 .9-2 2Zm20 8v-2H1v2h22Zm-6-8V3h-2v2h2ZM5 9V7H3v2h2Zm8-4V3h-2v2h2Zm8 0c0-1.1-.9-2-2-2v2h2Z", fill: "#000" }) }))); };
var Memo = memo(SvgBarcodeScanner);
export default Memo;
//# sourceMappingURL=BarcodeScanner.js.map